import { useFieldArray } from "react-hook-form";
import { TaxSectionProps } from ".";
import { InputButton } from "../../components/Forms/InputButton";
import { Button } from "../../components/Forms/InputButton/styles";
import { Tooltip } from "../../components/Tooltip";
import { EarlyCreditCardConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { CreditCardIcon } from "../../styles/icons/CreditCardIcon";
import { Rewind } from "../../styles/icons/Rewind";
import { clearMask } from "../../utils";
import { formatPaymentRangeFromApi, formatPaymentRangeToApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Flex, Text } from "../Sellers/styles";
import { Block, Divider, Header, Section } from "./styles";
import { Flex as ChackraFlex } from "@chakra-ui/react";

interface EarlyCreditCardSectionProps extends TaxSectionProps {
  earlyCreditCardConfigData: EarlyCreditCardConfig;
  defaultEarlyCreditCardConfigData: EarlyCreditCardConfig;
  allBuyerRatesAreDefault?: boolean;
  allSellerRatesAreDefault?: boolean;
  sellerPaymentReceiptType?:string;
  splitStatus?: boolean;

}

export function EarlyCreditCardSection({
  editionMode = false,
  earlyCreditCardConfigData,
  defaultEarlyCreditCardConfigData,
  asModalView,
  register,
  errors,
  watch,
  control,
  setValue,
  colorFinder,
  allBuyerRatesAreDefault,
  allSellerRatesAreDefault,
  sellerPaymentReceiptType,
  splitStatus,
}: EarlyCreditCardSectionProps) {
  useFieldArray({
    control,
    name: "earlyCreditCardBuyerRates"
  });
  useFieldArray({
    control,
    name: "earlyCreditCardSellerRates"
  });
  const delayForRedeem = formatTextView("earlyCreditCardDelayForRedeem", "delayForRedeem", formatPaymentRangeFromApi);
  function formatTextView(auxName: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean) {
    const defaultValueFormatted = formaterAsCurrency ? formater({ value: defaultEarlyCreditCardConfigData[innerValue] }) : formater(defaultEarlyCreditCardConfigData[innerValue]);
    const pastValue = formaterAsCurrency ? formater({ value: earlyCreditCardConfigData[innerValue] }) : formater(earlyCreditCardConfigData[innerValue]);
    const laterValue = watch(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  function handleSetDefaultValue(name: string | number, defaultValue: string, func: any, fieldArray?: string, objectField?: string) {
    const convertionFunction = {
      "range": formatPaymentRangeFromApi,
      "percentage": (value) => formatPercentageToNumber(value),
    }
    if (fieldArray) {
      const newArray = watch(fieldArray).map((item, index) => index === Number(name)
        ? convertionFunction[func](defaultEarlyCreditCardConfigData[objectField as string].at(Number(name)))
        : item
      );
      setValue(fieldArray, newArray);
      return;
    }
    setValue(name, convertionFunction[func](defaultEarlyCreditCardConfigData[defaultValue]))
  }
  function handleSetAllToDefaultValue(valueName: string, fieldArray: string) {
    setValue(valueName, defaultEarlyCreditCardConfigData[fieldArray].map(item => formatPercentageToNumber(item)));
  }
  return (
    <Section flexDir="column">
      <Section gap=".4rem" margin={asModalView ? "1rem 0 0" : ""}>
        <CreditCardIcon />
        <Header>Cartão Parcelado antecipado</Header>
        {splitStatus && (
          <ChackraFlex
            align="center"
            px="6px"
            color="#33594D"
            backgroundColor="#c1d3cd"
            borderRadius="4px"
          >
            Split
          </ChackraFlex>
        )}
      </Section>
      {!asModalView && (
        <>
          <Section>
            <InputButton
              label="Tempo de repasse"
              variant="ghost"
              bgColor="#EDF1F7"
              h="27px"
              width={asModalView ? "120px" : ""}
              tooltipButtonText="Redefinir para valor padão"
              mask="paymentRange"
              name="earlyCreditCardDelayForRedeem"
              register={{ ...register("earlyCreditCardDelayForRedeem") }}
              defaultValue={formatPaymentRangeFromApi(watch("earlyCreditCardDelayForRedeem"))}
              infoTooltipLabel={sellerPaymentReceiptType ? "Seu método de recebimento não permite edição de tempo de repasse" :""}
              sellerPaymentReceiptType={sellerPaymentReceiptType}
              disabled={!editionMode || sellerPaymentReceiptType === "TIMELINE" }
              buttonFunction={() => handleSetDefaultValue("earlyCreditCardDelayForRedeem", "delayForRedeem", "range")}
              color={() => colorFinder(formatPaymentRangeToApi(watch("earlyCreditCardDelayForRedeem")), defaultEarlyCreditCardConfigData?.delayForRedeem)}
              buttonDisabled={formatPaymentRangeToApi(watch("earlyCreditCardDelayForRedeem")) === defaultEarlyCreditCardConfigData?.delayForRedeem}
              icon={<Rewind color={formatPaymentRangeToApi(watch("earlyCreditCardDelayForRedeem")) === defaultEarlyCreditCardConfigData?.delayForRedeem ? "#00000040" : "black"} />}
              errors={errors?.earlyCreditCardDelayForRedeem}
            />

            
          </Section>
          <Section>
            <Flex flexDir="column" gap=".1rem">
              <Flex justifyContent="space-between">
                <Text color="var(--gray-400)" fontSize="12px">
                  Taxas Buyer
                </Text>
                {!asModalView && editionMode && (
                  <Button
                    disabled={allBuyerRatesAreDefault}
                    opacity="1"
                    borderRadius="2px"
                    border="1px solid transparent"
                    hoverBorder
                    onClick={() => handleSetAllToDefaultValue("earlyCreditCardBuyerRates", "buyerRates")}
                  >
                    <Tooltip text="Redefinir para valor padrão">
                      <Rewind color={allBuyerRatesAreDefault ? "#00000040" : "black"} />
                    </Tooltip>
                  </Button>
                )}
              </Flex>
              <Block>
                {earlyCreditCardConfigData?.buyerRates?.map((item, index) => (
                  <Section align="center">
                    <Text width="30px" fontSize="12px" color="var(--gray-400)">
                      {index + 2}x
                    </Text>
                    <InputButton
                      variant="ghost"
                      bgColor="#EDF1F7"
                      h="27px"
                      width={asModalView ? "120px" : "173px"}
                      tooltipButtonText="Redefinir para valor padão"
                      defaultValue={formatPercentageToNumber(item)}
                      mask="percentageRacional"
                      name={`earlyCreditCardBuyerRates.${index}`}
                      register={{ ...register(`earlyCreditCardBuyerRates.${index}` as const) }}
                      disabled={!editionMode}
                      infoTooltipLabel={sellerPaymentReceiptType ? "campo bloqueado pelo repasse" :""}
                      buttonFunction={() => handleSetDefaultValue(index, "rate", "percentage", "earlyCreditCardBuyerRates", "buyerRates")}
                      color={() => colorFinder(formatPercentageToNumber(watch(`earlyCreditCardBuyerRates.${index}`), true), defaultEarlyCreditCardConfigData.buyerRates.at(index))}
                      buttonDisabled={formatPercentageToNumber(watch(`earlyCreditCardBuyerRates.${index}`), true) === defaultEarlyCreditCardConfigData.buyerRates.at(index)}
                      icon={<Rewind color={formatPercentageToNumber(watch(`earlyCreditCardBuyerRates.${index}`), true) === defaultEarlyCreditCardConfigData.buyerRates.at(index) ? "#00000040" : "black"} />}
                    />
                    
                  </Section>
                ))}
                {errors?.earlyCreditCardBuyerRates && editionMode && (
                  <Text color="var(--red-600)" fontSize=".8rem">
                    {errors?.earlyCreditCardBuyerRates.at(0)?.message}
                  </Text>
                )}
              </Block>
            </Flex>
            <Flex flexDir="column" gap=".1rem">
              <Flex justifyContent="space-between">
                <Text color="var(--gray-400)" fontSize="12px">
                  Taxas Seller
                </Text>
                {!asModalView && editionMode && (
                  <Button
                    disabled={allSellerRatesAreDefault}
                    opacity="1"
                    borderRadius="2px"
                    border="1px solid transparent"
                    hoverBorder
                    onClick={() => handleSetAllToDefaultValue("earlyCreditCardSellerRates", "sellerRates")}
                  >
                    <Tooltip text="Redefinir para valor padrão">
                      <Rewind color={allSellerRatesAreDefault ? "#00000040" : "black"} />
                    </Tooltip>
                  </Button>
                )}
              </Flex>
              <Block>
                {earlyCreditCardConfigData?.sellerRates?.map((item, index) => (
                  <Section align="center">
                    <Text
                      width="30px"
                      fontSize="12px"
                      color="var(--gray-400)"
                    >
                      {index + 2}x
                    </Text>
                    <InputButton
                      variant="ghost"
                      bgColor="#EDF1F7"
                      h="27px"
                      width={asModalView ? "120px" : "173px"}
                      tooltipButtonText="Redefinir para valor padão"
                      defaultValue={formatPercentageToNumber(item)}
                      mask="percentageRacional"
                      name={`earlyCreditCardSellerRates.${index}`}
                      register={{ ...register(`earlyCreditCardSellerRates.${index}` as const) }}
                      disabled={!editionMode}
                      buttonFunction={() => handleSetDefaultValue(index, "rate", "percentage", "earlyCreditCardSellerRates", "sellerRates")}
                      color={() => colorFinder(formatPercentageToNumber(watch(`earlyCreditCardSellerRates.${index}`), true), defaultEarlyCreditCardConfigData.sellerRates.at(index))}
                      buttonDisabled={formatPercentageToNumber(watch(`earlyCreditCardSellerRates.${index}`), true) === defaultEarlyCreditCardConfigData.sellerRates.at(index)}
                      icon={<Rewind color={formatPercentageToNumber(watch(`earlyCreditCardSellerRates.${index}`), true) === defaultEarlyCreditCardConfigData.sellerRates.at(index) ? "#00000040" : "black"} />}
                    />
                  </Section>
                ))}
                {errors?.earlyCreditCardSellerRates && editionMode && (
                  <Text color="var(--red-600)" fontSize=".8rem">
                    {errors?.earlyCreditCardSellerRates.at(0)?.message}
                  </Text>
                )}
              </Block>
            </Flex>
          </Section>
        </>
      )}
      {asModalView && (
        <>
          <Section flexDir="column" gap=".1rem">
            <Text fontSize=".8rem" color="var(--gray-400)">
              Tempo de repasse
            </Text>
            {delayForRedeem}
          </Section>
          <Section>
            <Flex flexDir="column" gap="0">
              <Text color="var(--gray-400)" fontSize="12px">
                Taxas Buyer
              </Text>
              {earlyCreditCardConfigData?.buyerRates?.map((item, index) => (
                <Section align="center" gap="0">
                  <Section
                    borderRadius={index === 0 ? "4px 0 0 0" : "" || index === 10 ? "0 0 0 4px" : ""}
                    border="1px solid var(--gray-200)"
                    align="center"
                    borderRight="none"
                    borderBottom={index !== 10 ? "none" : ""}
                  >
                    <Text
                      display="flex"
                      align="center"
                      justify="center"
                      height="30px"
                      width="30px"
                      fontSize="12px"
                      color="var(--gray-200)"
                    >
                      {index + 2}x
                    </Text>
                  </Section>
                  <Section
                    borderRadius={index === 0 ? "0 4px 0 0" : "" || index === 10 ? "0 0 4px 0" : ""}
                    border="1px solid var(--gray-200)"
                    align="center"
                    borderBottom={index !== 10 ? "none" : ""}
                  >
                    <Text
                      height="30px"
                      display="flex"
                      align="center"
                      justify="space-around"
                      width="140px"
                      margin="0 1rem"
                      fontSize="12px"
                      color="black"
                    >
                      {item === formatPercentageToNumber(watch(`earlyCreditCardBuyerRates.${index}`), true) ? (
                        <Text fontSize=".9rem" color="var(--gray-200)">
                          {watch(`earlyCreditCardBuyerRates.${index}`)}
                        </Text>
                      ) : (
                        <>
                          <Text color={() => colorFinder(item, defaultEarlyCreditCardConfigData?.buyerRates?.at(index))} fontSize="0.8rem">
                            {formatPercentageToNumber(item)}
                          </Text>
                          <ArrowIcon size={14} />
                          <Text color={() => colorFinder(formatPercentageToNumber(watch(`earlyCreditCardBuyerRates.${index}`), true), defaultEarlyCreditCardConfigData?.buyerRates?.at(index))} fontSize="0.8rem">
                            {watch(`earlyCreditCardBuyerRates.${index}`)}
                          </Text>
                        </>
                      )}
                    </Text>
                  </Section>
                </Section>
              ))}
            </Flex>
            <Flex flexDir="column" gap="0">
              <Text color="var(--gray-400)" fontSize="12px">
                Taxas Seller
              </Text>
              {earlyCreditCardConfigData?.sellerRates?.map((item, index) => (
                <Section align="center" gap="0">
                  <Section
                    borderRadius={index === 0 ? "4px 0 0 0" : "" || index === 10 ? "0 0 0 4px" : ""}
                    border="1px solid var(--gray-200)"
                    align="center"
                    borderRight="none"
                    borderBottom={index !== 10 ? "none" : ""}
                  >
                    <Text
                      display="flex"
                      align="center"
                      justify="center"
                      height="30px"
                      width="30px"
                      fontSize="12px"
                      color="var(--gray-200)"
                    >
                      {index + 2}x
                    </Text>
                  </Section>
                  <Section
                    borderRadius={index === 0 ? "0 4px 0 0" : "" || index === 10 ? "0 0 4px 0" : ""}
                    border="1px solid var(--gray-200)"
                    align="center"
                    borderBottom={index !== 10 ? "none" : ""}
                  >
                    <Text
                      height="30px"
                      display="flex"
                      align="center"
                      justify="space-around"
                      margin="0 1rem"
                      width="140px"
                      fontSize="12px"
                      color="black"
                    >
                      {item === formatPercentageToNumber(watch(`earlyCreditCardSellerRates.${index}`), true) ? (
                        <Text fontSize=".9rem" color="var(--gray-200)">
                          {watch(`earlyCreditCardSellerRates.${index}`)}
                        </Text>
                      ) : (
                        <>
                          <Text color={() => colorFinder(item, defaultEarlyCreditCardConfigData?.sellerRates?.at(index))} fontSize="0.8rem">
                            {formatPercentageToNumber(item)}
                          </Text>
                          <ArrowIcon size={14} />
                          <Text color={() => colorFinder(formatPercentageToNumber(watch(`earlyCreditCardSellerRates.${index}`), true), defaultEarlyCreditCardConfigData?.sellerRates?.at(index))} fontSize="0.8rem">
                            {watch(`earlyCreditCardSellerRates.${index}`)}
                          </Text>
                        </>
                      )}
                    </Text>
                  </Section>
                </Section>
              ))}
            </Flex>
          </Section>
        </>
      )}
      {!asModalView && <Divider />}
    </Section>
  )
}